import React from 'react'
import PropTypes from 'prop-types'

import FastTrackLogo from '@argos/icons/esnext/FastTrack/FastTrack'
import PaymentIcon from '@argos/icons/esnext/Payment/Payment'
import ClickAndCollectIcon from '@argos/icons/esnext/ClickAndCollectBrand/ClickAndCollectBrand'
import OneManDeliveryIcon from '@argos/icons/esnext/OneManDelivery/OneManDelivery'
import * as Styled from './Propbar.styles'

const handlePropbarRoute = (evt, routes, href) => {
  for (let idx = 0; idx < routes.length; idx += 1) {
    const hasRouteMatch = href.indexOf(routes[idx].match) !== -1
    if (hasRouteMatch && routes[idx].handler && typeof routes[idx].handler === 'function') {
      evt.preventDefault()
      const matchesValidation = routes[idx].exact ? href === routes[idx].match : true
      if (matchesValidation) routes[idx].handler(evt, href)
    }
  }
}

const PropbarSlot = ({ routes, href, title, logo, firstBlock, secondBlock, dataTest }) => (
  <Styled.Slot data-test={dataTest} title={title} onClick={(evt) => handlePropbarRoute(evt, routes, href)} href={href}>
    {logo}
    {firstBlock}
    {secondBlock && secondBlock}
  </Styled.Slot>
)

const Propbar = ({ routes }) => (
  <Styled.Container className='xs-row container'>
    <PropbarSlot
      routes={routes}
      dataTest={'propbar-slot-1'}
      href='/features/delivery-collection-guide?tag=ar:propbar:samedaydelivery'
      title='Fast Track. Same Day Delivery. Order by 6pm. Terms apply. Only £3.95.'
      logo={
        <Styled.IconWrapper fastTrackIcon>
          <FastTrackLogo width='45' height='45' aria-hidden='true' />
          <OneManDeliveryIcon width='30' height='30' aria-hidden='true' />
        </Styled.IconWrapper>
      }
      firstBlock={
        <Styled.TextBlock aria-hidden='true'>
          <p>
            <Styled.Strong mauve>Same Day Delivery</Styled.Strong>
          </p>
          <p>Order by 6pm. Terms apply. </p>
        </Styled.TextBlock>
      }
      secondBlock={
        <Styled.TextBlock aria-hidden='true'>
          <p>Only £3.95</p>
        </Styled.TextBlock>
      }
    />

    <PropbarSlot
      routes={routes}
      dataTest={'propbar-slot-2'}
      href='/features/delivery-collection-guide?tag=ar:propbar:fasterinstorecollectionforfree'
      title='Click and collect. Pay online now or pay when you pick up in store.'
      logo={
        <Styled.IconWrapper clickAndCollectIcon>
          <ClickAndCollectIcon width='59' height='27' aria-hidden='true' />
        </Styled.IconWrapper>
      }
      firstBlock={
        <Styled.TextBlock aria-hidden='true'>
          <p>
            <Styled.Strong mauve>
              Pay online now or pay <br />
              when you pick up in-store
            </Styled.Strong>
          </p>
        </Styled.TextBlock>
      }
    />

    <PropbarSlot
      routes={routes}
      dataTest={'propbar-slot-3'}
      href='/help/argos-card/?tag=ar:propbar:argoscard'
      title='You can pay later with the argos card. Representative 29 point 9 percent APR variable.'
      logo={
        <Styled.IconWrapper paymentIcon>
          <PaymentIcon width='30' height='30' aria-hidden='true' />
        </Styled.IconWrapper>
      }
      firstBlock={
        <Styled.TextBlock aria-hidden='true'>
          <p>
            <Styled.Strong mauve>
              You can pay later <br />
              with the argos card
            </Styled.Strong>
          </p>
        </Styled.TextBlock>
      }
      secondBlock={
        <Styled.TextBlock aria-hidden='true'>
          <p>
            Representative <br />
            <Styled.Strong>29.9% APR</Styled.Strong> variable
          </p>
        </Styled.TextBlock>
      }
    />
  </Styled.Container>
)

Propbar.defaultProps = {
  routes: []
}

Propbar.propTypes = {
  /**
   * Specify an optional arry of objects that contain custom functions for the onClick of each slot
   */
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      match: PropTypes.string,
      exact: PropTypes.bool,
      handler: PropTypes.func
    })
  )
}

export default Propbar
